import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import DeletableChip from '../../../../../components/DeletableChip';
import PaginationWrapper from '../../../../../components/PaginationWrapper';
import PostalCodeInput from '../../../../../components/PostalCodeInput';
import SectionTitle from './SectionTitle';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

const ADDED_BG_COLOR = 'rgba(255, 149, 47, 0.12)';

class PostalCodeConfigSection extends Component {
    deletePostalCodeByZip = (zip) => {
        const { config, setConfig, editMode, showAlert } = this.props;

        const list = [...(config ?? [])];
        const idx = list.findIndex((x) => x?.zip === zip);

        if (idx >= 0) {
            if (editMode && (list[idx].added == null || list[idx].added === false)) {
                showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                return;
            }

            list.splice(idx, 1);
            setConfig?.(list);
        }
    };

    render() {
        const { config, setConfig, editMode, isPickupMode, showAlert } = this.props;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/map.png')}
                    label="Standort"
                />

                <PostalCodeInput
                    isPickupMode={isPickupMode}
                    onAdd={(postalCode) => {
                        if (editMode) {
                            if ((config?.length ?? 0) === 0) {
                                showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                                return;
                            }
                        } else if (isPickupMode) {
                            showAlert?.('Standortbeschränkungen sind bei Abholung nicht erlaubt.', ALERT_SEVERITY.WARNING);
                            return;
                        }

                        if ((config ?? []).some((x) => x?.zip === postalCode)) {
                            showAlert?.('Diese Postleitzahl existiert bereits.', ALERT_SEVERITY.WARNING);
                            return;
                        }

                        setConfig?.([{ zip: postalCode, added: true }, ...(config ?? [])]);
                    }}
                />

                <PaginationWrapper
                    items={config ?? []}
                    pageSize={10}
                    threshold={10}
                    disablePaginationOnSearch={true}
                    filterFn={(item, term) => (item?.zip ?? '').toLowerCase().includes(term)}
                >
                    {(pagedItems) =>
                        pagedItems?.length > 0 ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                }}
                            >
                                {pagedItems.map((postalCodeItem) => (
                                    <Box
                                        key={postalCodeItem.zip}
                                        sx={{
                                            width: {
                                                xs: '100%',
                                                sm: 'calc(50% - 4px)',
                                                md: 'calc(33.333% - 6px)',
                                            },
                                        }}
                                    // sx={{
                                    //     width: {
                                    //         xs: '100%',
                                    //         sm: 'calc(50% - 4px)',
                                    //     },
                                    // }}
                                    >
                                        <DeletableChip
                                            label={postalCodeItem.zip}
                                            onDelete={() => this.deletePostalCodeByZip(postalCodeItem.zip)}
                                            style={postalCodeItem.added ? { backgroundColor: ADDED_BG_COLOR } : null}
                                            disabled={editMode && postalCodeItem.added == null}
                                            showAlert={showAlert}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        ) : (config?.length ?? 0) > 0 ? (
                            <Typography sx={{ color: '#979797' }}>
                                Keine Ergebnisse
                            </Typography>
                        ) : null
                    }
                </PaginationWrapper>
            </Box>
        );
    }
}

export default PostalCodeConfigSection;